import React from "react";

import styles from "./ModalAuthReg.module.scss";
import { Link } from "react-router";
import ModalAuthRegInput from "./ModalAuthRegInput/ModalAuthRegInput";
import { warmupApi } from "../../../../config/api";
import { authService, LoginData } from "../../../../services/auth.service";

interface ModalAuthRegProps {
  isActive: boolean;
  setIsActive: (value: boolean) => void;
}

const DEFAULT_AUTH = {
  email: "",
  password: "",
};
const DEFAULT_REG = {
  username: "",
  email: "",
  tel: "",
};

const ModalAuthReg: React.FC<ModalAuthRegProps> = ({ isActive, setIsActive }) => {
  const [componentState, setComponentState] = React.useState({
    isAuth: false,
    isReg: true,
  });
  const [authData, setAuthData] = React.useState(DEFAULT_AUTH);
  const [regData, setRegData] = React.useState(DEFAULT_REG);
  const [isAgreedWithPolicty, setIsAgreedWithPolicy] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");

  const handleInputChange = (fieldName: string, value: string) => {
    if (componentState.isAuth) {
      setAuthData((prev) => ({
        ...prev,
        [fieldName]: value,
      }));
    }
    if (componentState.isReg) {
      setRegData((prev) => ({
        ...prev,
        [fieldName]: value,
      }));
    }
  };

  const formatLoginError = (detail: unknown): string => {
    const text = typeof detail === "string" ? detail : "";
    if (text.includes("Incorrect email or password")) {
      return "Неверный email или пароль. Проверьте данные или отключите автозаполнение и введите вручную.";
    }
    if (text.includes("Email not verified")) {
      return "Email не подтверждён. Проверьте почту или обратитесь к администратору.";
    }
    return text || "Ошибка авторизации. Проверьте подключение к интернету и попробуйте снова.";
  };

  const onFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setErrorMessage("");

    if (componentState.isAuth) {
      const form = e.currentTarget;
      const emailFromDom = (form.querySelector("#email") as HTMLInputElement | null)?.value ?? "";
      const passwordFromDom = (form.querySelector("#password") as HTMLInputElement | null)?.value ?? "";
      const email = (authData.email || emailFromDom).trim();
      const password = authData.password || passwordFromDom;

      if (!email || !password) {
        setErrorMessage("Не указан email или пароль. Пожалуйста, проверьте введённые данные и попытайтесь снова.");
        return;
      }

      try {
        await warmupApi();
        const loginData: LoginData = { email, password };
        const response = await authService.login(loginData);
        authService.saveToken(response.access_token);

        try {
          const user = await authService.getCurrentUser();
          authService.saveUserData(user);
        } catch {
          authService.saveUserData({
            id: 0,
            email,
            full_name: email,
            role: "manager",
            is_active: true,
            is_verified: true,
            created_at: new Date().toISOString(),
          });
        }

        setIsActive(false);


        window.location.hash = "/payment";
        window.location.reload();
      } catch (error: any) {
        if (!error.response) {
          setErrorMessage(
            "Не удалось связаться с сервером. В Chrome откройте консоль (F12) или попробуйте обновить страницу (Ctrl+F5)."
          );
          return;
        }
        setErrorMessage(formatLoginError(error.response?.data?.detail));
      }
    }

    if (componentState.isReg) {
      if (!isAgreedWithPolicty) {
        setErrorMessage("Необходимо согласие на обработку персональных данных");
        return;
      }
      if (!regData.email || !regData.tel || !regData.username) {
        setErrorMessage(
          "Не указано имя пользователя, почта или телефон. Пожалуйста, проверьте введённые данные и попытайтесь снова."
        );
      } else {
        setErrorMessage("");
      }
    }
  };

  return (
    <>
      <form onSubmit={onFormSubmit} className={styles.form}>
        {componentState.isAuth && (
          <>
            <h3 className={styles.title}>Добро пожаловать в Тканополис</h3>
            <p className={styles.first}>
              В первый раз здесь? &nbsp;
              <span
                onClick={() =>
                  setComponentState({
                    isAuth: false,
                    isReg: true,
                  })
                }
              >
                зарегистрируйтесь!
              </span>
            </p>
            <div className={styles.fields}>
              <div className={styles.field}>
                <ModalAuthRegInput
                  label="email"
                  title="Email*"
                  isEmail={true}
                  onChange={(value) => handleInputChange("email", value)}
                  required={true}
                />
              </div>
              <div className={styles.field}>
                <ModalAuthRegInput
                  label="password"
                  title="Пароль*"
                  isPassword={true}
                  onChange={(value) => handleInputChange("password", value)}
                  required={true}
                />
              </div>
            </div>
            {errorMessage && <p className={styles.error}>{errorMessage}</p>}
            <div className={styles.buttons}>
              <button type="submit" className={styles.entrance}>Войти</button>
              <button type="button" className={styles.forgottenPassword}>Забыли пароль?</button>
            </div>
          </>
        )}
        {componentState.isReg && (
          <>
            <h3 className={styles.title}>Добро пожаловать в Тканополис</h3>
            <p className={styles.first}>
              Уже есть аккаунт? &nbsp;
              <span
                onClick={() =>
                  setComponentState({
                    isAuth: true,
                    isReg: false,
                  })
                }
              >
                Войдите
              </span>
            </p>
            <div className={styles.fields}>
              <div className={styles.field}>
                <ModalAuthRegInput
                  label="username"
                  title="Имя пользователя*"
                  onChange={(value) => handleInputChange("username", value)}
                  required={true}
                />
              </div>
              <div className={styles.field}>
                <ModalAuthRegInput
                  label="email2"
                  title="Email*"
                  isEmail={true}
                  onChange={(value) => handleInputChange("email", value)}
                  required={true}
                />
              </div>
              <div className={styles.field}>
                <ModalAuthRegInput
                  label="tel"
                  title="Телефон*"
                  isTel={true}
                  onChange={(value) => handleInputChange("tel", value)}
                  required={true}
                />
              </div>
            </div>
            {errorMessage && <p className={styles.error}>{errorMessage}</p>}
            <div className={styles.policty}>
              <input
                type="checkbox"
                checked={isAgreedWithPolicty}
                onChange={(e) => setIsAgreedWithPolicy(e.target.checked)}
                id="policy"
                required
              />
              <label htmlFor="policy">
                Согласен(а) с <Link to="/policy">политикой обработки персональных данных</Link>
              </label>
            </div>
            <div className={isAgreedWithPolicty ? `${styles.register} ${styles.active}` : styles.register}>
              <button disabled={!isAgreedWithPolicty}>Зарегистрироваться</button>
            </div>
            <p className={styles.letter}>
              Мы отправим вам <span>письмо</span> с ссылкой для активации вашей <br /> учётной записи на{" "}
              <span>указанную вами почту.</span>
            </p>
          </>
        )}
      </form>
    </>
  );
};

export default ModalAuthReg;
